export default __webpack_public_path__ + "static/media/plan-add-objectives.96997c66.md";